__turbopack_context__.v({
  "container": "Tabs-module___pFzLa__container",
  "tab": "Tabs-module___pFzLa__tab",
  "tabContent": "Tabs-module___pFzLa__tabContent",
  "tabList": "Tabs-module___pFzLa__tabList",
  "tabList__rail": "Tabs-module___pFzLa__tabList__rail",
  "tabList__slider": "Tabs-module___pFzLa__tabList__slider",
  "tabList__tabs": "Tabs-module___pFzLa__tabList__tabs",
  "tab__active": "Tabs-module___pFzLa__tab__active",
  "tab__disabled": "Tabs-module___pFzLa__tab__disabled",
});
